import React, { useState, useRef } from 'react';
import styled from '../../styled';
import { media } from '../../themes/breakpoint';
import { zoomIn, zoomOut } from '../../keyframes';
import LoadingSpinner from '../loadingSpinner';
import * as Icons from '../icons';
const Container = styled.div `
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  overflow: hidden;
  z-index: ${({ theme }) => theme.zIndex.POPUP};
`;
const Overlay = styled.div `
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: ${({ theme }) => theme.colors.BLACK};
  opacity: 0.3;
  transition: background-color ease-in-out 0.3s;
`;
const Wrapper = styled.div `
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  justify-content: center;
  align-items: center;
  width: calc(100% - 8rem);
  height: calc(100% - 8rem);

  > svg {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  ${media.mobile `
    width: calc(100% - 2rem);
    height: calc(100% - 2rem);
  `};
`;
const Image = styled.img `
  max-width: 100%;
  max-height: 100%;
  border-radius: 8px;
  opacity: ${({ isLoading }) => (isLoading ? '0' : '1')};
  animation: ${({ isShow }) => (isShow ? zoomIn : zoomOut)} 0.3s ease-in-out
    both;
`;
const CrossWrapper = styled.div `
  position: absolute;
  top: 0;
  right: 0;
  padding: 0.75rem;
  border-radius: 0 0 0 8px;
  line-height: 0;
  background-color: ${({ theme }) => theme.colors.INK_800};

  &:hover {
    cursor: pointer;
    background-color: ${({ theme }) => theme.colors.INK_700};
  }

  ::before {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    opacity: 0.9;
  }
`;
const ImagePreviewModal = ({ image, onClose }) => {
    const [isLoading, setIsLoading] = useState(true);
    const [isShow, setIsShow] = useState(false);
    const imageRef = useRef(null);
    const handleImageLoaded = () => {
        setIsLoading(false);
        setIsShow(true);
    };
    const handleClick = () => {
        setIsShow(false);
    };
    const handleClickOutside = (event) => {
        if (imageRef &&
            imageRef.current &&
            !imageRef.current.contains(event.target) &&
            isShow) {
            setIsShow(false);
        }
    };
    const handleAnimationEnd = () => {
        if (!isShow) {
            onClose();
        }
    };
    return (React.createElement(Container, null,
        React.createElement(Overlay, { onClick: handleClickOutside }),
        React.createElement(Wrapper, { onClick: handleClickOutside },
            React.createElement(Image, { ref: imageRef, src: image, onLoad: handleImageLoaded, onError: handleImageLoaded, isShow: isShow, isLoading: isLoading, onAnimationEnd: handleAnimationEnd }),
            isLoading && React.createElement(LoadingSpinner, null)),
        !isLoading && (React.createElement(CrossWrapper, { onClick: handleClick },
            React.createElement(Icons.Solid.Cross, { size: "LARGE", color: "SNOW_100" })))));
};
export default ImagePreviewModal;
//# sourceMappingURL=index.js.map